import React from 'react';
import styles from './PaymentInvoices.module.css';

const BulkEmailStatusModal = ({
  isOpen,
  eligibleCount,
  excludedCount,
  isUpdating,
  updateError,
  actionLabel = 'Sent Email',
  actionBg = '#2980b9',
  onConfirm,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className={styles.modalBg}
      onClick={e => e.target === e.currentTarget && onClose()}
    >
      <div className={styles.modalBox} style={{ width: 380 }}>
        <div className={styles.modalTitle}>Mark as Email Sent</div>
        <div className={styles.modalSub}>
          <strong>{eligibleCount}</strong>{' '}
          invoice{eligibleCount !== 1 ? 's' : ''} will be updated to{' '}
          <strong>{actionLabel}</strong>
        </div>

        {excludedCount > 0 && (
          <div
            style={{
              padding: '8px 12px',
              background: '#fffbe6',
              border: '1px solid #ffe58f',
              borderRadius: 8,
              marginBottom: 14,
              fontSize: 12.5,
              color: '#7d6608',
            }}
          >
            {excludedCount} PAID invoice{excludedCount !== 1 ? 's' : ''} excluded — already finalised.
          </div>
        )}

        {updateError && (
          <div
            style={{
              padding: '10px 14px',
              background: '#fff0f0',
              border: '1px solid #f5c2c2',
              borderRadius: 8,
              marginBottom: 14,
              fontSize: 12.5,
              color: '#c0392b',
            }}
          >
            {updateError.message || 'An unexpected error occurred.'}
          </div>
        )}

        <div
          className={styles.modalActions}
          style={{ flexDirection: 'column', gap: 8, marginTop: 4 }}
        >
          <button
            className={styles.btn}
            style={{
              justifyContent: 'center',
              padding: 11,
              background: actionBg,
              borderColor: actionBg,
              color: '#fff',
              fontWeight: 600,
            }}
            disabled={isUpdating}
            onClick={onConfirm}
          >
            {isUpdating ? 'Updating…' : actionLabel}
          </button>
          <button
            className={`${styles.btn} ${styles.btnSecondary}`}
            style={{ justifyContent: 'center', padding: 11 }}
            disabled={isUpdating}
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkEmailStatusModal;
